export default {
  // Settings card
  title: 'Agencies',
  description: "The agencies that supply your subcontractors and labour-hire workers. Give each of those workers the agency responsible for them, then filter the reports by agency.",
  noAgencies: 'No agencies yet',
  noAgenciesHint: 'Add the agencies you use, then assign one to each subcontractor.',
  addAgency: 'Add agency',
  newTitle: 'New agency',
  editTitle: 'Edit agency',
  editAgency: 'Edit {name}',
  deleteAgency: 'Delete {name}',
  deleteTitle: 'Delete agency',
  deleteMessage: 'Delete {name}? This can\'t be undone.',
  agencyAdded: 'Agency added.',
  agencySaved: 'Agency saved.',
  agencyDeleted: 'Agency deleted.',
  fieldName: 'Name',
  fieldContactName: 'Contact person',
  fieldContactEmail: 'Contact email',
  fieldContactPhone: 'Contact phone',
  fieldNotes: 'Notes',
  fieldActive: 'Active',
  activeHint: "An inactive agency can't be given to anyone new. People already with it keep it, and it still shows in reports.",
  inactive: 'Inactive',
  peopleOne: '{count} person',
  peopleOther: '{count} people',

  // Filters and columns shared by the reports
  filter: 'Filter by agency',
  all: 'All agencies',
  direct: 'No agency (own employees)',
  inactiveName: '{name} (inactive)',
  colAgency: 'Agency',

  // Employee form
  formLabel: 'Agency',
  formHint: 'The agency responsible for this person. It is used to filter reports.',
  formChoose: 'Choose an agency',
  formNoAgencies: 'No agencies yet. Add them under Settings, then come back.',
}
